import styled, { keyframes, css } from 'styled-components';

interface Props {
  openCollapsible: boolean;
}

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(180deg);
  }
`;

export const Img = styled.img<Props>`
  animation: ${props =>
    props.openCollapsible
      ? css`
          animation: ${rotate} 2s linear;
          transform: rotate(180deg);
        `
      : ``};
`;
